import React, { Component } from 'react';
import Panel                from '../../../components';
import PropTypes            from 'prop-types';
import { connect } from "react-redux";

import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  HelpBlock,
  Alert
} from 'react-bootstrap';
import { createBrowserHistory } from 'history';

import { NewBreadcrumb as BreadcrumbComponent } from '../../../components';
import loader from '../../../style/loader/loader.scss';
import { withRouter, Link } from 'react-router-dom';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import isEmpty from 'lodash.isempty';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';

import FormValidator from '../../../_helpers/FormValidator';

import 'rc-color-picker/assets/index.css';
import ColorPicker from 'rc-color-picker';

import {designCenterActions}    from '../../../redux/actions/designCenterActions';
import {renderAlert,clearAlert, alertsActions} from '../../../redux/actions/alertsActions';
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class AssetsAdd extends React.Component  {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);

    this.validator = new FormValidator([
      { 
        field: 'started_at', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Field is required.' 
      },
      { 
        field: 'ended_at', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Field is required.' 
      },
      { 
        field: 'background_color', 
        method: this.checkBackgroungColor,   // notice that we are passing a custom function here
        validWhen: true, 
        message: 'Please choose Background Color.'
      },
      { 
        field: 'display_image', 
        method: this.checkDisplayImage,   // notice that we are passing a custom function here
        validWhen: true, 
        message: 'Please upload Display Image.'
      },
      { 
        field: 'ended_at', 
        method: this.checkDateRange,   // notice that we are passing a custom function here validation
        validWhen: true, 
        message: 'Invalid Date Range.'
      }
    ]);

    this.state = {
      menuKey: 'ADD_ASSET',
      path: ['Home', 'Assets Lists', 'Add New'], 
      links:['home','assets/list','assets/add'],
      asset_type: 'background',
      assetDetail:{},
      started_at: '',
      ended_at: '',
      display_image: '',
      background_type: '1',
      background_color: '',
      status:'1',
      msg_status: 'hide',
      alertMessage:'',
      show: false,
      msgType: '',
      loading:false,
      message: '',
      currDate: new Date(),
      validation: this.validator.valid(),
      cityList: [],
      cityID: '',
      asset_lang: 'en',
      multi_lang: 'no',
      logo_destination_status:'1',
      logo_destination_value:''
    };

    this.handleInputChange=this.handleInputChange.bind(this);
    this.submitted = false;
  }

  checkBackgroungColor = (bgColor, state) => {
    if(state.asset_type == 'background' && state.background_type == 2 && !bgColor)
    {
      return false;
    }
    else
    {
      return true
    }
  }

  checkDisplayImage = (displayImage, state) => {
    let validImage = ['image/jpeg', 'image/png'];
    if((!displayImage) ||(displayImage && validImage.indexOf(state.display_image.type) < 0)){
      return false;
    }
    else
    {
      return true;
    }
  }

  checkDateRange = (checkDate, state) => {
    let startedAt = new Date(state.started_at);
    let endedAt = new Date(state.ended_at);
    let currDate = new Date();
    return true;
  }


  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  
  onDateChange = (dtype, date) => {
    this.setState({
      [dtype]:date,
    });
  }

  componentDidMount() {
    const {
      actions: { getCityDetail }
    } = this.props;
    getCityDetail();
    if (this.props.error) {
      this.setState({ loading: false });
    }
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus')); 
    if(siteData){ 
      if(siteData.multi_lang=="yes")
      {
        this.setState({ 
          multi_lang: siteData.multi_lang, 
          asset_lang: siteData.default_lang,
        }); 
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.assetDetail !== nextProps.assetDetail) {
      if(nextProps.assetDetail && nextProps.assetDetail.response){
        this.setState({
          msgType: nextProps.assetDetail.response,
          message: nextProps.assetDetail.message,
          loading:false
        });
         window.scrollTo(0, 0);
      }
    }
    if (this.props.error !== nextProps.error) {
      if(nextProps.error)
      {
        this.setState({
          msgType: 'error',
          message: nextProps.error,
          loading:false
        });
         window.scrollTo(0, 0);
      }
    }
    
    setTimeout(
      function() {
          this.setState({
            msgType: '',
            message: ''
          });
      }
      .bind(this),
      5000
    );

    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }
  }

  handleFormSubmit = event => {
    event.preventDefault();

    const validation = this.validator.validate(this.state);
    this.setState({ validation });
    this.submitted = true;
    
    if (validation.isValid) {
      // handle actual form submission here
      this.setState({
        loading:true
      });
      const formData = new FormData();
      formData.append('display_image', this.state.display_image);
      if(this.state.background_type == 1){
        formData.append('background_color', '');
      }

      if(this.state.asset_type == 'background' && this.state.background_type == 2){
        formData.append('background_color', this.state.background_color);
      }
      formData.append('asset_type', this.state.asset_type);
      formData.append('background_type', this.state.background_type);
      formData.append('ended_at', moment(this.state.ended_at).format("YYYY-MM-DD HH:mm:ss"));
      formData.append('started_at', moment(this.state.started_at).format("YYYY-MM-DD HH:mm:ss"));
      formData.append('status', this.state.status);
      formData.append('cityID', this.state.cityID);
      formData.append('lang', this.state.asset_lang);

      formData.append('logo_destination_status', this.state.logo_destination_status);
      formData.append('logo_destination_value', this.state.logo_destination_value);
      
      const { actions: { addAsset } } = this.props;
      addAsset(formData);
    }
    else
    {
      this.setState({
        loading:false
      });
    }
  }

  handleselectedFile = event => {
    this.setState({
      display_image: event.target.files[0]
    })
  }

  handleColorChange = event => {
    this.setState({
      'background_color': event.color
    });

  }

  renderAlert(){
    if(this.state.msgType && this.state.message) {
      let msgClass = (this.state.msgType=='error') ? 'alert alert-danger' : 'alert alert-'+this.state.msgType;
      return(
        <div className={msgClass}>
          <strong>{this.state.msgType.toUpperCase()} :</strong> {this.state.message}
        </div>
      )
    }
  }

  render() {
    let validation = this.submitted ?                         // if the form has been submitted at least once
                      this.validator.validate(this.state) :   // then check validity every time we render
                      this.state.validation                   // otherwise just use what's in state

    let bgType, bgTypeOption,logoLinkOption1,logoLinkOption2,logoLinkOption3;
    if(this.state.asset_type == 'background'){
      bgType = <FormGroup controlId="formBackgroundType">
            <ControlLabel>Background Type</ControlLabel>
            <FormControl className="halfWidth" componentClass="select" name="background_type" onChange={this.handleInputChange.bind(this)} value={this.state.background_type}>
              <option value="1">Repeated background</option>
              <option value="2">Centered background</option>
             </FormControl>
          </FormGroup>;
    }

    if(this.state.asset_type == 'logo'){
      logoLinkOption1 =   <FormGroup controlId="formLogoStatus">
                      <ControlLabel>Clickthrough Logo Destination</ControlLabel>
                    </FormGroup>;
      logoLinkOption2 =  <FormGroup controlId="formLogoStatus">
                      <ControlLabel>Logo Status</ControlLabel>
                      <FormControl componentClass="select" name="logo_destination_status" onChange={this.handleInputChange} value={this.state.logo_destination_status}>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </FormControl>
                    </FormGroup>;
      logoLinkOption3 =<FormGroup controlId="formLogoValue">
                      <ControlLabel>Logo Value</ControlLabel>
                            <FormControl
                      type="text"
                      value={this.state.logo_destination_value}
                      placeholder="Logo Value"
                      onChange={this.handleInputChange}
                      name="logo_destination_value"
                    />
                    </FormGroup>;
                
    }



    if(this.state.asset_type == 'background' && this.state.background_type == 2)
    {
      bgTypeOption = <FormGroup controlId="formBackgroundColor" className={(validation.background_color.isInvalid) && 'has-error'}>
        <ControlLabel> <span style={{color: "red"}}>*</span>Background Color (in hex code)</ControlLabel>
        <FormControl
          type="text"
          value={this.state.background_color}
          placeholder="Background Color"
          onChange={this.handleInputChange}
          name="background_color"
          style={{borderColor:this.state.backgroundColorError}}
        />
        <ColorPicker
          color={this.state.background_color}
          name="background_color"
          onChange={this.handleColorChange}
          value={this.state.background_color}
        >
          <span className="react-custom-trigger">Choose Color</span>
        </ColorPicker>
        <span className="help-block">{validation.background_color.message}</span>
      </FormGroup>;
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {(this.state.loading === true) ?
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }

        <form>
          {this.renderAlert()}
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
      
          <div className="panel">
            <header className="panel-heading">New Asset
            <Button bsSize="xsmall" bsStyle="success" onClick={() => this.context.router.history.push('/assets/list')}> Assets Listing  </Button>
            </header>
        
            {this.state.show && this.state.alertMessage !=='' &&        
              <div className="col-lg-12">
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </div>
            } 
       
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={8} xs={12} mdOffset={2}>
                    {(this.state.multi_lang=='yes') &&
                      <FormGroup controlId="formAssetlang" >
                        <ControlLabel> 
                          <span style={{color: "red"}}>*</span>  Asset Language
                        </ControlLabel>
                        <FormControl 
                          className="halfWidth" 
                          componentClass="select" 
                          name="asset_lang" 
                          style={{borderColor:this.state.assetlangError}} 
                          onChange={this.handleInputChange} 
                          value={this.state.asset_lang}
                        >
                          <option value="en">English</option>
                          <option value="fr">French</option> 
                        </FormControl>
                      </FormGroup>
                    }

                    <FormGroup controlId="formAssetType" >
                      <ControlLabel> <span style={{color: "red"}}>*</span>  Asset Type</ControlLabel>
                      <FormControl className="halfWidth" componentClass="select" name="asset_type" style={{borderColor:this.state.assetTypeError}} onChange={this.handleInputChange} value={this.state.asset_type}>
                        <option value="background">Background</option>
                        <option value="logo">Logo</option>
                        <option value="favicon">Favicon</option>
                        <option value="NoRecord">No Record Image</option>
                        <option value="ogimage">Default OG Image</option>
                      </FormControl>
                    </FormGroup>
                    {bgType}
                    {bgTypeOption}
                    
                    <FormGroup controlId="formDisplayImage" className={(validation.display_image.isInvalid) && 'has-error'}>
                      <ControlLabel>Display Image</ControlLabel>
                      <FormControl 
                        type="file" 
                        name="display_image" 
                        onChange={this.handleselectedFile} 
                        style={{borderColor:this.state.displayImageError}}
                        >
                      </FormControl>
                      <span className="help-block">{validation.display_image.message}</span>
                    </FormGroup>
                    {(this.state.asset_type!='ogimage') && 
                      <FormGroup controlId="formDisplayCity">
                        <ControlLabel>City</ControlLabel>
                        <FormControl componentClass="select" value={this.state.cityID} name="cityID" placeholder="select" onChange={this.handleInputChange}>
                            <option value="">All City</option>
                            {(this.state.cityList) &&
                              this.state.cityList.map((data, index) =>
                                <optgroup key={'hcity'+index} label={data.country}>
                                  {(data.cities) &&
                                    data.cities.map((city, index) => 
                                      <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                    )
                                  }
                                </optgroup>
                              )
                            }
                        </FormControl>
                      </FormGroup>
                    }
                    <FormGroup className={(validation.started_at.isInvalid || validation.ended_at.isInvalid) && 'has-error'}>
                      <ControlLabel className="halfWidth">Schedule</ControlLabel>              
                      Start 
                      <DateTimePicker
                        name="started_at"
                        value={this.state.started_at}
                        //minDate={this.state.currDate}
                        onChange={this.onDateChange.bind(this,'started_at')}
                      />
                      <span className="help-block">{validation.started_at.message}</span>
                      <ControlLabel className="halfWidth">Until</ControlLabel>              
                      <DateTimePicker
                        name="ended_at"
                        value={this.state.ended_at}
                        //minDate={this.state.started_at}
                        onChange={this.onDateChange.bind(this,'ended_at')}
                      />
                      <span className="help-block">{validation.ended_at.message}</span>
                    </FormGroup>
                                 
                    <FormGroup controlId="formStatus">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl componentClass="select" name="status" onChange={this.handleInputChange} value={this.state.status}>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </FormControl>
                    </FormGroup>

                   {logoLinkOption1}{logoLinkOption2}{logoLinkOption3}

                  </Col>
                </Row>              
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button bsStyle="info" type="button" onClick={this.handleFormSubmit} id="saveButton" disabled={this.props.loading} >Save</Button>
              <Button bsStyle="default" onClick={() => this.context.router.history.push(`/assets/list`)}>Cancel</Button>
            </Col>
          </Row>
        </form>
      </div>
    )
  }
};

const mapStateToProps = (state) => {
  return {
    error: state.designCenterReducer.error,
    assetDetail: state.designCenterReducer.assetDetail,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    loading: state.designCenterReducer.loading,
    cityList: state.frontReducer.cityList,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        ...designCenterActions,
        ...alertsActions
      },
      dispatch)
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetsAdd));



// WEBPACK FOOTER //
// ./src/app/views/admin/designCenter/AssetsAdd.js